export default __webpack_public_path__ + "static/media/icon-qr-appcoopeuch-appgallery.6adc6283.svg";